import { render } from "./QuestionAndAnswer.vue?vue&type=template&id=7a5d6919"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__